/* ============================================================================
   Unisex Size Selector — companion script (v5)
   Save as: assets/unisex-size-selector.js

   Approche : MutationObserver pour intercepter l'apparition de fieldsets
   unisex dans le DOM et leur appliquer immédiatement le bon état (gender
   stocké dans sessionStorage) AVANT que le navigateur ne les peigne.

   Cette approche fonctionne même sur les versions du thème Clean Canvas
   Enterprise qui ne dispatch pas l'event 'on:variant:before-replace-element'.
   ============================================================================ */

(function () {
  var STORAGE_KEY = 'uss-active-gender';

  function getStoredGender() {
    try {
      var v = sessionStorage.getItem(STORAGE_KEY);
      return (v === 'men' || v === 'women') ? v : 'men';
    } catch (e) {
      return 'men';
    }
  }

  function setStoredGender(g) {
    try { sessionStorage.setItem(STORAGE_KEY, g); } catch (e) { /* noop */ }
  }

  function parseSize(value) {
    var match = value.match(
      /M(?:en'?s)?\s*([\d.]+H?)\s*\/\s*W(?:omen'?s)?\s*([\d.]+H?)/i
    );
    if (!match) return { men: value, women: value };
    return {
      men:   match[1].replace('H', '.5'),
      women: match[2].replace('H', '.5')
    };
  }

  function updateSpansForGender(fieldset, gender) {
    fieldset.querySelectorAll('.opt-btn').forEach(function (input) {
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var span = label.querySelector('span');
      if (!span) return;

      if (!span.dataset.ussOriginal) {
        span.dataset.ussOriginal = input.value;
      }

      var parsed = parseSize(span.dataset.ussOriginal);
      var newText = parsed[gender];
      if (span.textContent !== newText) {
        span.textContent = newText;
      }
    });
  }

  function applyGender(fieldset, gender) {
    if (fieldset.getAttribute('data-active-gender') !== gender) {
      fieldset.setAttribute('data-active-gender', gender);
    }
    fieldset.querySelectorAll('.uss-tab').forEach(function (t) {
      var isActive = t.dataset.gender === gender;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    updateSpansForGender(fieldset, gender);
  }

  function bindTabClicks(fieldset) {
    fieldset.querySelectorAll('.uss-tab').forEach(function (tab) {
      if (tab.dataset.ussBound === 'true') return;
      tab.dataset.ussBound = 'true';

      tab.addEventListener('click', function () {
        var gender = tab.dataset.gender;
        setStoredGender(gender);
        applyGender(fieldset, gender);
      });
    });
  }

  function initSelector(fieldset) {
    applyGender(fieldset, getStoredGender());
    bindTabClicks(fieldset);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.option-selector--unisex-size')
      .forEach(initSelector);
  }

  // ---- Initial load --------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ---- MutationObserver: detect new fieldsets injected by variant-picker --
  // Quand le thème remplace la fieldset après un changement de variant, on
  // applique le bon gender immédiatement (synchrone) avant le paint suivant.
  var observer = new MutationObserver(function (mutations) {
    var fieldsetsToFix = [];

    mutations.forEach(function (mut) {
      mut.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return; // skip text nodes

        // Le node ajouté est-il lui-même une fieldset unisex ?
        if (node.matches && node.matches('.option-selector--unisex-size')) {
          fieldsetsToFix.push(node);
        }
        // Ou contient-il une fieldset unisex ?
        if (node.querySelectorAll) {
          node.querySelectorAll('.option-selector--unisex-size').forEach(function (fs) {
            fieldsetsToFix.push(fs);
          });
        }
      });
    });

    if (fieldsetsToFix.length > 0) {
      var gender = getStoredGender();
      fieldsetsToFix.forEach(function (fs) {
        applyGender(fs, gender);
        bindTabClicks(fs);
      });
    }
  });

  // Observer le body entier — coût négligeable, et garantit qu'on capte
  // toute fieldset unisex peu importe où elle est ré-insérée
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ---- Compat avec les versions récentes du thème (before-replace event) --
  document.addEventListener('on:variant:before-replace-element', function (evt) {
    var replaceWith = evt.detail && evt.detail.replaceWith;
    if (!replaceWith) return;

    var fieldsets = [];
    if (replaceWith.matches && replaceWith.matches('.option-selector--unisex-size')) {
      fieldsets.push(replaceWith);
    }
    if (replaceWith.querySelectorAll) {
      replaceWith.querySelectorAll('.option-selector--unisex-size').forEach(function (f) {
        fieldsets.push(f);
      });
    }

    fieldsets.forEach(function (fs) {
      applyGender(fs, getStoredGender());
    });
  });

  // ---- Post-swap safety net ------------------------------------------------
  document.addEventListener('on:variant:change', function () {
    initAll();
  });
})();